import IBModuleApi from "../../api/rolecatalogAPI";
import { urlContexts } from "../../constants";

export const getRolesByTenant = async (tenantId: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/role?tenantId=${tenantId}`
  );

  return data;
};

export const createRoles = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/role`,
    createInfo
  );

  return data;
};

export const updateRoles = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/role/${updateInfo?.id}`,
    {
      ...updateInfo,
      id: undefined,
      status: undefined,
    }
  );

  return data;
};

export const deleteRoles = async (deleteInfo: any) => {
  const { data } = await IBModuleApi.delete(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/role/${deleteInfo?.id}`
  );

  return data;
};

export const reactiveRoles = async (reactiveInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/role/${reactiveInfo?.id}/reactivate`
  );

  return data;
};